import React from 'react';
import { Star, ShoppingCart, Eye, Heart } from 'lucide-react';
import img1 from '../components/images/our_product/esl.png'
import img2 from '../components/images/our_product/AI-scale.png'
import img3 from '../components/images/our_product/antenna.png'
import img4 from '../components/images/our_product/retailweighing.png'
import img5 from '../components/images/our_product/sunmi.png'
import img6 from '../components/images/our_product/coding.png'
import img7 from '../components/images/our_product/handjet.png'
import img8 from '../components/images/our_product/industrialweighing.png'


const ProductCatalog = () => {
  // Sample product data - replace with your actual products
  const products = [
    {
    id: 1,
    name: "Electronic Shelf Label",
    category: "Retail Technology",
    image: img1,
    price: 120.00,
    rating: 4.5,
    badge: "Digital Pricing",
  },
  {
    id: 2,
    name: "AI Weighing Scale",
    category: "Retail Equipment",
    image: img2,
    price: 450.00,
    rating: 4.7,
    badge: "Precision Weighing",
  },
  {
    id: 3,
    name: "EAS Antenna",
    category: "Retail Security",
    image: img3,
    price: 300.00,
    rating: 4.4,
    badge: "Loss Prevention",
  },
  {
      id: 4,
      name: "Weighing Scales",
      price: "$899",
      originalPrice: "$1,099",
      image: img4,
      rating: 4.7,
      reviews: 156,
      badge: "True-to-Weight",
      category: "Retail Weighing"
    },
  {
    id: 5,
    name: "POS System",
    category: "Retail POS Solutions",
    image: img5,
    price: 650.00,
    rating: 4.8,
    badge: "Checkout System",
  },
  {
    id: 6,
    name: "Coding Machine",
    category: "Industrial Printing",
    image: img6,
    price: 550.00,
    rating: 4.6,
    badge: "Batch & Expiry Printing",
  },
  {
    id: 7,
    name: "Handjet Printer",
    category: "Industrial Marking",
    image: img7,
    price: 700.00,
    rating: 4.7,
    badge: "Portable Printing",
  },
  {
      id: 8,
      name: "Industrial scales",
      price: "$29",
      originalPrice: "$39",
      image: img8,
      rating: 4.4,
      reviews: 78,
      badge: "Adjustable",
      category: "Accessories"
  },
    // {
    //   id: 9,
    //   name: "4K Webcam",
    //   price: "$129",
    //   originalPrice: "$169",
    //   image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=400&h=400&fit=crop",
    //   rating: 4.7,
    //   reviews: 112,
    //   badge: "HD Quality",
    //   category: "Video"
    // },
    // {
    //   id: 10,
    //   name: "USB-C Hub",
    //   price: "$69",
    //   originalPrice: "$89",
    //   image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=400&fit=crop",
    //   rating: 4.5,
    //   reviews: 95,
    //   badge: "Multi-Port",
    //   category: "Connectivity"
    // }
  ];

  const getBadgeColor = (badge) => {
    const colors = {
      'Precision Weighing': 'bg-gradient-to-r from-yellow-400 to-orange-500',
      'Digital Pricing': 'bg-gradient-to-r from-green-400 to-emerald-500',
      'Loss Prevention': 'bg-gradient-to-r from-purple-500 to-pink-500',
      'Checkout System': 'bg-gradient-to-r from-red-500 to-rose-500',
      'Batch & Expiry Printing': 'bg-gradient-to-r from-green-500 to-teal-500',
      'True-to-Weight': 'bg-gradient-to-r from-indigo-500 to-purple-600',
      'Portable Printing': 'bg-gradient-to-r from-blue-500 to-cyan-500',
      'Adjustable': 'bg-gradient-to-r from-amber-500 to-orange-600',
      'HD Quality': 'bg-gradient-to-r from-violet-500 to-purple-600',
      'Multi-Port': 'bg-gradient-to-r from-slate-600 to-slate-700'
    };
    return colors[badge] || 'bg-gray-500';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Header Section */}
      <div className="container mx-auto px-6 py-16">
        <div className="text-center mb-16">
          <div className="inline-block">
            <h1 className="text-[39px] font-bold bg-gradient-to-r from-[#01557a] via-[#00663b] to-[#01557a] bg-clip-text text-transparent mb-5 font-poppins">
              Our Tools for Your Success
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-green-900 to-blue-700 mx-auto mb-5 rounded-full"></div>
          </div>
          <p className="text-lg text-slate-600 max-w-4xl mx-auto leading-relaxed font-poppins">
            Discover our carefully curated selection of cutting-edge technology and premium accessories. 
            Each product is handpicked for quality, innovation, and exceptional value.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-slate-200/50 hover:scale-[1.02] hover:-translate-y-2"
            >
              {/* Badge */}
              <div className="absolute top-4 left-4 z-10">
                <span className={`px-3 py-1 text-xs font-bold text-white rounded-full shadow-lg ${getBadgeColor(product.badge)}`}>
                  {product.badge}
                </span>
              </div>

              {/* Wishlist Button */}
              <button className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-red-50 hover:scale-110">
                <Heart className="w-5 h-5 text-slate-600 hover:text-red-500 transition-colors" />
              </button>

              {/* Product Image */}
              <div className="relative overflow-hidden rounded-t-3xl">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Quick Action Buttons */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="flex space-x-3">
                    <button className="w-12 h-12 bg-white/95 backdrop-blur-sm rounded-full shadow-xl flex items-center justify-center hover:bg-purple-600 hover:text-white transition-all duration-300 transform hover:scale-110">
                      <Eye className="w-5 h-5" />
                    </button>
                    <button className="w-12 h-12 bg-white/95 backdrop-blur-sm rounded-full shadow-xl flex items-center justify-center hover:bg-green-600 hover:text-white transition-all duration-300 transform hover:scale-110">
                      <ShoppingCart className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-6">
                <div className="mb-2">
                  <span className="text-sm font-medium text-purple-600 bg-purple-50 px-2 py-1 rounded-full">
                    {product.category}
                  </span>
                </div>
                
                <h3 className="text-lg font-bold text-slate-900 mb-3 line-clamp-2 group-hover:text-purple-700 transition-colors">
                  {product.name}
                </h3>
                
                {/* Rating */}
                <div className="flex items-center mb-4">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-slate-300'}`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-slate-600 ml-2">
                    {product.rating} ({product.reviews})
                  </span>
                </div>
                
                {/* Price */}
                {/* <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-2xl font-bold text-slate-900">
                      {product.price}
                    </span>
                    <span className="text-sm text-slate-500 line-through">
                      {product.originalPrice}
                    </span>
                  </div> */}
                  
                  {/* Discount Percentage */}
                  {/* <div className="text-sm font-bold text-green-600 bg-green-50 px-2 py-1 rounded-full">
                    {Math.round((1 - parseInt(product.price.replace(/[$,]/g, '')) / parseInt(product.originalPrice.replace(/[$,]/g, ''))) * 100)}% OFF
                  </div>
                </div> */}
                
                {/* Add to Cart Button */}
                <button className="w-full mt-6 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-3 px-6 rounded-2xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl">
                  Explore Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        {/* <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-4 bg-white rounded-2xl shadow-xl p-8 border border-slate-200/50">
            <div className="text-left">
              <h3 className="text-2xl font-bold text-slate-900 mb-2">
                Can't find what you're looking for?
              </h3>
              <p className="text-slate-600">
                Get in touch with our expert team for personalized recommendations
              </p>
            </div>
            <button className="bg-gradient-to-r from-slate-900 to-slate-700 hover:from-slate-800 hover:to-slate-600 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap">
              Contact Us
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ProductCatalog;